import { createWebBackApi } from '../../api/webBackApi';

const webBackApi = createWebBackApi({
  timeout: 180000, // 180 segundos para peticiones largas como /check-last-24-hours/all
});



export const getFullFtpData = async () => {
  try {
    const response = await webBackApi.get("/api/v1/ftp-users/full-data");
    return response.data;
  } catch (error) {
    console.error("Error creating FTP user:", error);
    throw error;
  }
};

export const getUserMonitoring = async (feedId) => {
  try {
    const response = await webBackApi.get(`/api/s3-images/monitoring/user/${feedId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching monitoring for user ${feedId}:`, error);
    throw error;
  }
};

export const getUserMonitoringByDate = async (feedId, date) => {
  try {
    const response = await webBackApi.get(`/api/s3-images/monitoring/user/${feedId}/date/${date}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching monitoring for user ${feedId} on date ${date}:`, error);
    throw error;
  }
};

export const getAllMonitoring = async () => {
  try {
    const response = await webBackApi.get("/api/s3-images/monitoring/all");
    return response.data;
  } catch (error) {
    console.error("Error fetching all monitoring data:", error);
    throw error;
  }
};

export const getMinuteRangeMonitoring = async (date, hour, startMinute, endMinute) => {
  try {
    const response = await webBackApi.get(`/api/s3-images/monitoring/minute-range/date/${date}/hour/${hour}/start-minute/${startMinute}/end-minute/${endMinute}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching minute range monitoring data:", error);
    throw error;
  }
};

export const getTodayMonitoringData = async () => {
  try {
    const response = await webBackApi.post("/api/s3-images/count-received-images-today");
    return response.data;
  } catch (error) {
    console.error("Error fetching today's monitoring data:", error);
    throw error;
  }
};

export const generateDataForSpecificDateMonitoring = async (date) => {
  try {
    const response = await webBackApi.post(`/api/s3-images/count-received-images/date/${date}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching monitoring data for date ${date}:`, error);
    throw error;
  }
};

export const getHistoryMonitoringData = async () => {
  try {
    const response = await webBackApi.get(`/api/monitor/history`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching history monitoring data`, error);
    throw error;
  }
};

export const getAssets = async () => {
  try {
    const response = await webBackApi.get("/api/s3-images/check-last-24-hours/all");
    return response.data;
  } catch (error) {
    console.error("Error fetching assets:", error);
    throw error;
  }
};
